//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import mapRequestDataModel from "@/components/Diagram/mapRequestDataModel.vue";
import ruleEditorMapRequest from "@/components/Diagram/ruleEditorMapRequest.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "SetExternalStartMapRequest",
    components: {
        mapRequestDataModel, draggable, ruleEditorMapRequest, AQModal, AQButton, AQCard
    },
    props: ["nrMappedFields"],
    data() {
        return {
            mapRequestModal: true,
            showMapRequestDataModelModal: false,
            currentStep: 1,
            requests: {},
            requestDef: false,
            drag: false,
            editRulesModal: false,
            dataToLoad: [],
            ghostStepHidden: false,
            objectRequest: [],
            rulesParentArray: [],
            ruleId: null,
            done: { label: this.$t("generic.done"), disabled: true }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["getExternalMapReqData", "selectedPluginConfigData"])
    },
    created() {
        if (this.nrMappedFields) {
            this.currentStep = 3;
        } else {
            this.currentStep = 1;
        }
    },
    methods: {
        actionsDlg($event) {
            if ($event === "primary") {
                this.$emit("getDataFromMapReqModal", {
                    dataModelFields: this.dataToLoad.length ? this.dataToLoad[0].requestDataModel : this.selectedPluginConfigData.externalStart.dataModelFields,
                    startParams: Object.keys(this.requests).length ? this.requests : this.selectedPluginConfigData.externalStart.startParams,
                    rules: this.rulesParentArray
                });
            }
            this.$emit("closeMapRequestModal");
        },
        modalClosed() {
            this.showMapRequestDataModelModal = false;
        },
        ruleModalClosed() {
            this.editRulesModal = false;
        },
        addRulesModal() {
            this.editRulesModal = true;
        },
        finishStepper() {
            this.done.disabled = false;
            this.$refs.stepper.next();
        },
        step() {
            this.objectRequest = this.dataToLoad && this.dataToLoad.length ? this.dataToLoad[0].requestDataModel : [];
            if (!this.rulesParentArray.length) {
                this.rulesParentArray = this.selectedPluginConfigData && this.selectedPluginConfigData.rules ? this.selectedPluginConfigData.rules : [];
            }
        },
        addRule() {
            this.editRulesModal = true;
            this.ruleId = null;
        },
        showButton(value) {
            this.requestDef = value;
        },
        sendRequestValue(value) {
            this.dataToLoad = [];
            if (value) {
                [this.requests] = value;
                this.requestDef = value[2].requestVariable;
                this.dataToLoad.push({ requestDataModel: value[1] });
            }
        },
        rulesFinalArray(value) {
            let found = false;
            for (let i = 0; i < this.rulesParentArray.length; i++) {
                if (this.rulesParentArray[i].uuid === value.uuid) {
                    this.rulesParentArray[i] = value;
                    this.rulesParentArray[i].index = i;
                    found = true;
                }
            }
            if (!found) {
                const obj = {
                    uuid: value.uuid,
                    name: value.name,
                    description: value.description,
                    conditions: value.conditions,
                    index: this.rulesParentArray.length ? this.rulesParentArray.length : 0,
                    errorCode: value.errorCode,
                    errorMessage: value.errorMessage
                };
                this.rulesParentArray.push(obj);
            }
        },
        editRule(ruleId) {
            this.editRulesModal = true;
            this.ruleId = ruleId;
        }
    }
};

